import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { Store } from '@ngrx/store'
import { AppState } from '../store/state/app.state'
import { DynamicComponentLoaderService } from '../services/dynamic-component-loader/dynamic-component-loader.service'
import { AuthService } from '../services/auth/auth.service'
import { initialInitializeState } from '../store/state/initial.state'
import { GlobalConstants } from '../constants/global-constants'
import { AuthType } from '../models/model'

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private clientSelectorActive = false

  constructor(
    private authService: AuthService,
    private appState: Store<AppState>,
    private dynamicComponentLoaderService: DynamicComponentLoaderService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isUserAuthenticated = this.authService.isUserAuthenticated()
    if (!isUserAuthenticated) {
      this.authService.redirectToLandingPage()
      return false
    } else {
      this.appState
        .select(state => state.initialize)
        .subscribe(initializeState => {
          if (initializeState !== initialInitializeState) {
            if (initializeState?.user?.passwordAutoGenerated && AuthType.PASSWORD === initializeState?.userAuthType) {
              this.dynamicComponentLoaderService.loadComponent(GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.key)
            }
            if (initializeState.selectedCompanies && initializeState.selectedCompanies.length === 0) {
              if (!this.clientSelectorActive) {
                this.clientSelectorActive = true
                this.dynamicComponentLoaderService.loadComponent(GlobalConstants.DYNAMIC_MODEL.CLIENT_SELECTOR.key)
              }
            } else if (initializeState.selectedCompanies && initializeState.selectedCompanies.length > 0) {
              this.clientSelectorActive = false
            }
          }
        })
    }
    return true
  }
}
